export enum VeridIDs {
  APP_ORG_ID = 'healix',
  HRH_ORG_APP = 'hrh',
  SELF_DECLARED_VERIFICATION_METHOD_ID = '00000000-0000-0000-0000-000000001001',
  PERSONAL_KNOWLEDGE_VERIFICATION_METHOD_ID = '00000000-0000-0000-0000-000000000102',
  SELF_DECLARED_VERIFICATION_METHOD_ID_HEALIX = '00000000-0000-0000-0000-000000002001',
  PERSONAL_KNOWLEDGE_VERIFICATION_METHOD_ID_HEALIX = '00000000-0000-0000-0000-100000000002',
}
